import { DAILY_UI } from '@/constants';
import { MasonaryGridItem, MasonaryGridObj } from '@/types';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cx(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function shuffleArray<T>(array: T[]) {
  // Create a copy of the original array to avoid modifying the original
  const shuffledArray = [...array];

  // Fisher-Yates (Knuth) Shuffle Algorithm
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }

  return shuffledArray;
}

export const getRandomMasonryLayout = (totalItems: number, columns: number) => {
  const shuffledLayout: MasonaryGridItem[][] = [];
  let shuffledSubLayout: MasonaryGridItem[] = [];

  const shuffled = shuffleArray<MasonaryGridItem>(Object.values(DAILY_UI));
  let count = 0;
  for (let i = 0; i < totalItems; i++) {
    const currentItem = shuffled[i];
    if (currentItem !== undefined) {
      count++;
      shuffledSubLayout.push(currentItem);
      if (count === totalItems / columns) {
        shuffledLayout.push(shuffledSubLayout);
        shuffledSubLayout = [];
        count = 0;
      }
    }
  }
  return shuffledLayout;
};

export const getRandomMasonryHeroLayout = (list: MasonaryGridObj, desiredOrders: number[][]) => {
  const squareImages: MasonaryGridItem[] = [];
  const rectangleImages: MasonaryGridItem[] = [];
  const shuffledLayout: MasonaryGridItem[] = [];

  Object.values(list).forEach((item) => {
    if (item.height === 418) {
      squareImages.push(item);
    } else {
      rectangleImages.push(item);
    }
  });

  const squareShuffled = shuffleArray<MasonaryGridItem>(squareImages);
  const rectangleShuffled = shuffleArray<MasonaryGridItem>(rectangleImages);

  const randomOrder = desiredOrders[Math.floor(Math.random() * desiredOrders.length)];

  for (let i = 0; i < randomOrder.length; i++) {
    const currentItem = randomOrder[i] ? squareShuffled[i] : rectangleShuffled[i];
    if (currentItem !== undefined) {
      shuffledLayout.push(currentItem);
    }
  }

  return shuffledLayout;
};
